Drupal.behaviors.ingredientFilterFormatterV1 = {
  attach: function (context) {
    var template = context.querySelector('.js-ingredients-filter-formatter--v1');
    var gridContainer = context.querySelector('.js-ingredients-formatter-grid');
    var filterSelect = template.querySelector('select.js-ingredients-formatter-filter__dropdown');
    var filterChip = template.querySelectorAll('.js-ingredients-formatter-filter__chip');
    var filterSort = template.querySelectorAll('.js-ingredients-formatter-sorts__item');
    var gridCollection = Array.from(
      template.querySelectorAll('.js-ingredient-basic--v1,.js-basic-tout')
    );
    var selectValue = '';
    var toutsPlaceholder = [];
    var mixer = mixitup('.js-ingredients-formatter-grid', {
      selectors: {
        target: '.js-filter'
      },
      controls: {
        enable: false
      },
      animation: {
        enable: false
      }
    });

    gridCollection.forEach(function (element, index) {
      if (element.classList.contains('js-basic-tout')) {
        toutsPlaceholder.push({
          item: element,
          position: index
        });
      }
    });

    function deferredAnimation() {
      if (gridContainer.classList.contains('mixitup-loaded')) {
        mixer.configure({
          animation: {
            enable: true
          }
        });
      } else {
        gridContainer.classList.add('mixitup-loaded');
      }
    }

    function sortIngredients() {
      var sortBy = template
        .querySelector('.js-ingredients-formatter-sorts__item.active')
        .getAttribute('data-filter');
      var gridWithoutTouts = Array.from(template.querySelectorAll('.js-ingredient-basic--v1'));
      var sortedCollection = _.sortBy(gridWithoutTouts, function (item) {
        return item.getAttribute('data-sort-' + sortBy);
      });

      _.each(toutsPlaceholder, function (tout) {
        if (tout) {
          sortedCollection.splice(tout.position, 0, tout.item);
        }
      });
      deferredAnimation();
      mixer.sort(sortedCollection);
    }

    sortIngredients();

    function filterByType(filterValue) {
      var newValue = 'all';
      var sortValue = template
        .querySelector('.js-ingredients-formatter-sorts__item.active')
        .getAttribute('data-filter');

      if (filterValue) {
        if (sortValue === '1') {
          newValue = selectValue
            ? '.js-filter--' + filterValue + '.js-filter2--' + selectValue
            : '.js-filter--' + filterValue;
        } else {
          newValue = selectValue
            ? '.js-filter3--' + filterValue + '.js-filter2--' + selectValue
            : '.js-filter3--' + filterValue;
        }
      } else {
        newValue = selectValue ? '.js-filter2--' + selectValue : 'all';
      }
      deferredAnimation();
      mixer.filter(newValue);
    }

    filterChip.forEach((a) =>
      a.addEventListener('click', () => {
        var value = a.getAttribute('data-filter');

        filterChip.forEach((el) => el.classList.remove('active'));
        a.classList.add('active');
        filterByType(value);
      })
    );

    filterSort.forEach((a) =>
      a.addEventListener('click', () => {
        var chipValue = template
          .querySelector('.js-ingredients-formatter-filter__chip.active')
          .getAttribute('data-filter');

        filterSort.forEach((el) => el.classList.remove('active'));
        a.classList.add('active');

        filterByType(chipValue);
        sortIngredients();
      })
    );

    filterSelect.onchange = function () {
      var chipValue = template
        .querySelector('.js-ingredients-formatter-filter__chip.active')
        .getAttribute('data-filter');

      selectValue = this.value;
      this.classList.add('active');

      filterByType(chipValue);
    };
  }
};
